export type ExpensesCategory = {
  _id: string
  name: string
  description?: string
  active: boolean
  createdAt?: string
  createdBy?: string
  updatedAt?: string
  updatedBy?: string
}

export type ExpensesStatus = 'pending' | 'approved' | 'updating' | 'cancelled'
export enum ExpensesStatusEnum {
  PENDING = 'pending',
  APPROVED = 'approved',
  UPDATING = 'updating',
  CANCELLED = 'cancelled',
}

type ApprovalMetadata = {
  userId: string
  approvalDate?: string
  rejectionDate?: string
  notes?: string
  reimbursementDate?: string
}

export type ExpenseItem = {
  _id: string
  categoryId: string
  itemDescription: string
  amount: number
  receiptUrl: string
}

export type Expense = {
  _id: string
  refNumber: string
  churchId: string
  requester: string
  requesterEmail: string
  expenseItems: Array<ExpenseItem>
  date: string
  amount: number
  notes?: string
  status: ExpensesStatus
  createdAt: string
  createdBy?: string
  localPastor?: ApprovalMetadata
  adminPastor?: ApprovalMetadata
  adminTreasurer?: ApprovalMetadata
  updatedAt?: string
  updatedBy?: string
}
